import { ModelCommentThread } from './ModelCommentThread';
import type { Position } from '@view-model/models/common/types/ui';
import { ModelCommentEntity } from './ModelCommentEntity';
import type { ILayout } from '@view-model/ui/layouts';
import type { ModelCommentThreadId, UserId } from 'balus-common';

export class CreatingModelComment {
  private constructor(
    public readonly id: ModelCommentThreadId,
    public readonly userId: UserId,
    public readonly body: string,
    public readonly position: Readonly<Position>
  ) {}

  static buildNew(userId: UserId, position: Readonly<Position>): CreatingModelComment {
    const id = ModelCommentThread.buildNewId();
    return new this(id, userId, '', position);
  }

  move(dx: number, dy: number): CreatingModelComment {
    const {
      id,
      userId,
      body,
      position: { x, y },
    } = this;
    return new CreatingModelComment(id, userId, body, { x: x + dx, y: y + dy });
  }

  withBody(body: string): CreatingModelComment {
    const { id, userId, position } = this;
    return new CreatingModelComment(id, userId, body, position);
  }

  buildThread(): ModelCommentThread {
    const { id, userId, body } = this;
    const primaryComment = ModelCommentEntity.buildNew(userId, body);
    return new ModelCommentThread(id, 'Open', primaryComment, [], [userId]);
  }

  snapLayout(layout: ILayout): CreatingModelComment {
    const { id, userId, body, position } = this;
    return new CreatingModelComment(id, userId, body, layout.snapPosition(position));
  }
}
